import React from "react";
import "./Results.css";

const url =
  "https://www.namecheap.com/domains/registration/results/?domain=%27%3B";

const Results = ({ suggestedName }) => {
  return (
    <div className="result-container">
      {suggestedName.map((name) => {
        return (
          <div className="wrapper" key={name}>
            <a href={`${url}${name}`} className="link">
              <p className="result-name">{name}</p>
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default Results;
